import { Component } from '@angular/core';
import {RSDialogService} from '../libs/rsnotify/rsdialog.service';
import {RSDialog} from '../libs/rsnotify/rsdialog';
import {UserService} from './services/user.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {RSLoadingModalService} from '../libs/rsloading/rsloading.service';
import {Router} from '@angular/router';
import {LocalStorage, LocalStorageService} from '@efaps/ngx-store';
import {DataService} from './services/data.service';
import {RSDebuggerService} from '../libs/rsdebugger/rsdebugger.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('menuItemAnimation', [
      state('true', style({opacity: 1})),
      state('false', style({opacity: 0, width: '0px', display: 'none', visibility: 'hidden'})),
      transition('false <=> true', animate('100ms ease'))
    ]),
    trigger('padSubLevel', [
      state('true', style({'padding-left': '15px'})),
      state('false', style({'padding-left': 'inherit'})),
      transition('false <=> true', animate('200ms ease'))
    ]),
    trigger('slideInOut', [
      state('open', style({
        height: '56px',
        visibility: 'visible'
      })),
      state('opensub', style({
        height: '42px',
        visibility: 'visible'
      })),
      state('closed', style({
        height: '0',
        visibility: 'hidden',
        opacity: '0'
      })),
      transition('open => closed, opensub => closed', [
        animate('0.2s')
      ]),
      transition('closed => open, closed => opensub', [
        animate('0.2s')
      ]),
    ])
  ]
})
export class AppComponent {
  title = 'manager';

  public debugClicked = 0;
  private debugClickedClear;
  public thisYear$ = new Date().getFullYear();
  public version$ = '0.0.0';

  private isAnimating$ = false;
  @LocalStorage('navigationExpanded') navigationExpanded$ = false;
  public navigationVisible$ = true;
  public sideLinks$ = [
    {path: '/home', icon: 'home', name: 'Home'},
    {path: '/growers', icon: 'settings_accessibility', name: 'Growers'},
    {path: '/contacts', icon: 'family_restroom', name: 'Other Contacts'},
    {path: '/events', icon: 'today', name: 'Workshops & Field Days'},
    {path: '/meetings', icon: 'groups', name: 'Meetings'},
    // {path: '/activities', icon: 'category', name: 'Extension Activities'},
    // {path: '/practice', icon: 'published_with_changes', name: 'Practice Change'},
    {path: '/reports', icon: 'insights', name: 'Reports'},
    {path: '/settings', icon: 'settings', name: 'Settings'},
  ];
  constructor(
      private rsDialog: RSDialogService,
      private rsLoading: RSLoadingModalService,
      public userService: UserService,
      public dataService: DataService,
      private router: Router,
      private rsDebugger: RSDebuggerService,
      private lsService: LocalStorageService) {
    this.version$ = (require('../../package.json') as any).version; // Hacky
  }

  public async shouldLogoutUser() {
    if (!this.hasUser()) {
      return;
    }

    const shouldLogout = await this.rsDialog.showConfirmDialog('Would you like to log out of this account?', false, 'Logout', RSDialog.Style.WARN);
    if (!shouldLogout) {
      return;
    }

    await this.logOutUser();
  }

  public async logOutUser() {
    this.rsLoading.show();
    try {
      await this.userService.signOut();
    } catch (e) {
      console.error(e);
      this.rsDialog.showErrorDialog(e.message ? e.message : e);
    }
    this.rsLoading.hide();
    await this.router.navigate(['login']);
  }

  public hasUser() {
    return this.userService.hasActiveUser;
  }

  debugMode() {
    this.debugClicked++;
    if (typeof this.debugClickedClear) {
      clearTimeout(this.debugClickedClear);
      this.debugClickedClear = false;
    }
    this.debugClickedClear = setTimeout(() => this.debugClicked = 0, 500);

    console.log(this.debugClicked);
    if (this.debugClicked === 10) {
      this.debugClicked = 0;
      this.debugClickedClear = setTimeout(() => {
        this.rsDialog.showConfirmDialog('Do you want to enable debug mode', false, 'Debug Mode', RSDialog.Style.WARN).then(
            (bValue) => this.userService.debug = !!bValue,
            (oError) => {}
        );
      }, 1000);
    }
  }

  navigate(path) {
    console.log('navigate', path);
  }

  sidebarShow(bShow: boolean) {
    this.navigationExpanded$ = !!bShow;
  }

  public onActivate(e, outlet) {
    outlet.scrollTop = 0;
  }

  // TODO: Animation bug, as per; https://github.com/angular/material2/issues/9837
  // Fix as per; https://stackblitz.com/edit/angular-o5fjz1?file=app%2Fapp.component.css

  startAnimation() {
    this.isAnimating$ = true;
    this.tickAnimation();
  }

  doneAnimation() {
    this.isAnimating$ = false;
  }

  tickAnimation() {
    if (this.isAnimating$) {
      requestAnimationFrame(() => this.tickAnimation());
    }
  }
}
